import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import pimg1 from '../../images/clients/logo-1.webp'
import pimg2 from '../../images/clients/logo-2.webp'
import pimg3 from '../../images/clients/logo-3.webp'
import pimg4 from '../../images/clients/logo-4.webp'
import pimg5 from '../../images/clients/logo-5.webp'
import pimg6 from '../../images/clients/logo-6.webp'
import pimg7 from '../../images/clients/logo-7.webp'
import pimg8 from '../../images/clients/logo-8.webp'
import pimg9 from '../../images/clients/logo-9.webp'
import pimg10 from '../../images/clients/logo-10.webp'
import pimg11 from '../../images/clients/logo-11.webp'
import pimg12 from '../../images/clients/logo-12.webp'
import pimg13 from '../../images/clients/logo-13.webp'
import pimg14 from '../../images/clients/logo-14.webp'
import pimg15 from '../../images/clients/logo-15.webp'
import pimg16 from '../../images/clients/logo-16.webp'
import pimg17 from '../../images/clients/logo-17.webp'
import pimg18 from '../../images/clients/logo-18.webp'
import pimg19 from '../../images/clients/logo-19.webp'
import pimg20 from '../../images/clients/logo-20.webp'

const partners = [
    {
        pImg: pimg1,
    },
    {
        pImg: pimg2,
    },
    {
        pImg: pimg3,
    },
    {
        pImg: pimg4,
    },
    {
        pImg: pimg5,
    },
    {
        pImg: pimg6,
    },
    {
        pImg: pimg7,
    },
    {
        pImg: pimg8,
    },
    {
        pImg: pimg9,
    },
    {
        pImg: pimg10,
    },
    {
        pImg: pimg11,
    },
    {
        pImg: pimg12,
    },
    {
        pImg: pimg13,
    },
    {
        pImg: pimg14,
    },
    {
        pImg: pimg15,
    },
    {
        pImg: pimg16,
    },
    {
        pImg: pimg17,
    },
    {
        pImg: pimg18,
    },
    {
        pImg: pimg19,
    },
    {
        pImg: pimg20,
    },
]

var settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,

    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 7,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 350,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};



const PartnerSection = (props) => {

    return (
        <div className="client_logo_carousel">
            <Slider {...settings}>
                {partners.map((partner, pitem) => (
                    <div className="client_logo_item" key={pitem}>
                        <img src={partner.pImg} alt="Techco - Client Logo" />
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default PartnerSection;